import PropTypes from 'prop-types';
export const formControlPropTypes = {
  /**
   * Children as node
   */
  children: PropTypes.node,
  /**
   * Additional classname
   */
  classname: PropTypes.string,
  /**
   * Function fired onSubmit event
   */
  onSubmit: PropTypes.func
};